import { Button, Icon } from '@sbv-clients/ui-shared';

import { SideDrawerType, UseContextFnTypeForPageSideDrawer } from './util';

export function DraftsButton({
  useContextFn,
}: {
  useContextFn: () => UseContextFnTypeForPageSideDrawer;
}) {
  const { sideDrawerState, setSideDrawerState } = useContextFn();
  const open = sideDrawerState === SideDrawerType.DRAFTS;
  const handleOnClick = () => {
    setSideDrawerState(open ? undefined : SideDrawerType.DRAFTS);
  };

  return (
    <Button
      sx={{ minWidth: 92 }}
      color={'warning'}
      variant={open ? 'contained' : 'text'}
      endIcon={<Icon name={'EditCalendar'} />}
      onClick={handleOnClick}
      size={'small'}
    >
      Drafts
    </Button>
  );
}
